const init = () => {
	const $button = $('.js-footer-button');
	const $popup = $('.js-footer-popup');

	let isOpen = false;

	$button.on('click', () => {
		$popup.toggleClass('isVisible');

		if (!isOpen) {
			gsap.to(window, {
				onStart() {
					isOpen = true;
				},
				duration: 1,
				scrollTo: {
					y: '.js-footer-button',
				},
				ease: 'power3.inOut',
			}, 0);
		} else {
			isOpen = false;
		}
	});
};

export default {
	init,
};
